<template>
  <div class="return-visit-details">
    <div class="table-filter">
      <div class="form-row">
        <div class="form-input">
          <span>回访类型</span>
          <el-select
            v-model="type"
            placeholder="请选择"
            @change="selectVisitType"
          >
            <el-option
              v-for="item in typeList"
              :key="item.value"
              :label="item.text"
              :value="item.value"
            />
          </el-select>
        </div>
      </div>
    </div>
    <div class="table-body">
      <el-table
        :data="itemList"
        border
        stripe
        :header-cell-style="{
          background: '#4c84ff',
          color: '#fff',
          height: '60px',
          textAlign: 'center'
        }"
      >
        <el-table-column prop="visit_time" label="回访日期" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.visit_time.substr(0, 11) }}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="type_name"
          label="回访类型"
          align="center"
        />
        <el-table-column prop="extra" label="回访信息" width="400">
          <template slot-scope="scope">
            <div v-if="scope.row.type_id == '1'">
              <p style="margin-bottom: 10px">
                沟通内容：{{ scope.row.extra.content }}
              </p>
              <p style="margin-bottom: 10px">
                问题及解决方案：{{ scope.row.extra.problem }}
              </p>
              <p style="margin-bottom: 10px">
                联系方式：{{ scope.row.extra.contact }}
              </p>
            </div>
            <div v-else-if="scope.row.type_id == '2'">
              <p style="margin-bottom: 10px">
                学员目前情况：{{ scope.row.extra.content }}
              </p>
              <p style="margin-bottom: 10px">
                问题及解决方案：{{ scope.row.extra.problem }}
              </p>
              <p style="margin-bottom: 10px">
                解决建议及下阶段计划：{{ scope.row.extra.proposal }}
              </p>
            </div>
            <div v-else-if="scope.row.type_id == '3'">
              <p style="margin-bottom: 10px">
                退费&结课原因：{{ scope.row.extra.content }}
              </p>
              <p style="margin-bottom: 10px">
                家长建议与需求：{{ scope.row.extra.proposal }}
              </p>
            </div>
            <div v-else>
              <p style="margin-bottom: 10px">
                沟通内容：{{ scope.row.extra.content }}
              </p>
              <p style="margin-bottom: 10px">
                问题及解决建议：{{ scope.row.extra.problem }}
              </p>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="images" label="回访照片" align="center">
          <template slot-scope="scope">
            <div
              v-if="scope.row.images != ''"
              class="visit-image"
              @click="showImages(scope.row.images)"
            >
              <img :src="scope.row.images.split(',')[0]" alt>
              <div>
                共{{ scope.row.images.split(",").length }}张，
                <span class="main-font-color">查看大图</span>
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          prop="editor_name"
          label="创建人"
          align="center"
        />
        <el-table-column
          prop="create_time"
          label="创建时间"
          align="center"
        />
      </el-table>
    </div>
    <el-dialog title="收货地址" :visible.sync="imageModalVisible">
      <el-carousel
        arrow="always"
        trigger="click"
        height="667px"
        :autoplay="false"
        @change="changeImage"
      >
        <el-carousel-item v-for="item in nowSwiper" :key="item">
          <div class="carousel-slide">
            <img :src="item" alt>
          </div>
        </el-carousel-item>
      </el-carousel>
      <div class="image-total center-self-x">
        {{ nowImage }}/{{ nowSwiper.length }}
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'ReturnVisitDetails',
  components: {},
  data() {
    return {
      itemList: [],
      typeList: [
        { text: '全部', value: '' },
        { text: '回访', value: '1' },
        { text: '家长会', value: '2' },
        { text: '退费/结课', value: '3' },
        { text: '其他', value: '4' }
      ],
      type: '',
      child_id: '',
      imageModalVisible: false,
      nowSwiper: [],
      nowImage: 1
    }
  },
  computed: {},
  watch: {},
  mounted() {
    this.child_id = this.$route.query.child_id
    this.getInfoVisit({
      child_id: this.child_id,
      type: this.type
    })
  },
  methods: {
    async getInfoVisit(obj) {
      const ret = await this.$http.getInfoVisit(obj)
      if (ret.code == 200) {
        this.itemList = ret.data.list
      }
    },
    selectVisitType() {
      this.getInfoVisit({
        child_id: this.child_id,
        type: this.type
      })
    },
    showImages(images) {
      this.nowSwiper = images.split(',')
      this.imageModalVisible = true
    },
    changeImage(val) {
      this.nowImage = val + 1
    }
  }
}
</script>
<style lang="scss" scoped>
.return-visit-details {
  .table-filter {
    padding-top: 20px;
  }
  .visit-image {
    cursor: pointer;
    img {
      width: 60px;
    }
  }
  ::v-deep .el-dialog {
    width: 375px;
    .el-dialog__header {
      display: none;
    }
    .el-dialog__body {
      padding: 0;
      position: relative;
      .el-carousel__container {
        .carousel-slide {
          width: 376px;
          img {
            width: 100%;
            height: 100%;
          }
        }
        .el-carousel__arrow {
          background-color: rgba(0, 0, 0, 0.7);
        }
      }
      .el-carousel__indicators {
        display: none;
      }
      .image-total {
        width: 74px;
        height: 30px;
        border-radius: 500px;
        background-color: rgba(0, 0, 0, 0.7);
        font-size: 16px;
        color: #fff;
        bottom: 10px;
        z-index: 2;
        text-align: center;
        line-height: 30px;
      }
    }
  }
}
</style>
